import styled from "styled-components";

const Container = styled.div`
  padding: 0 20px 50px 20px;

  .hideElement {
    visibility: hidden;
  }
  
  > :not(:last-child) {
    margin-bottom: 15px;
  }
`;

const ContainerShowMoreButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export { Container, ContainerShowMoreButton };
